export default {
  methods: {
    clipboard_copy(value, message = null) {
      const succeed = () => message && this.$alert.raiseSuccess(message);
      const fail    = () => this.$alert.raiseError("Copy failed");

      if (navigator.clipboard) {
        navigator.clipboard.writeText(value).then(succeed).catch(() => this._clipboardFallback(value, succeed, fail));
      } else {
        this._clipboardFallback(value, succeed, fail);
      }
    },

    _clipboardFallback(value, succeed, fail) {
      const el = document.createElement("textarea");
      el.value = value;
      el.style.cssText = "position:fixed;opacity:0;pointer-events:none";
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand("copy") ? succeed() : fail();
      } catch {
        fail();
      } finally {
        document.body.removeChild(el);
      }
    }
  }
};
